import BackspaceIcon from "@mui/icons-material/Backspace";
import EditIcon from "@mui/icons-material/Edit";
import {PuiDialog, PuiFormikForm, PuiGrid, PuiLoadingBackdrop, PuiSection,} from "@portnet/ui";
import {Formik} from "formik";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import AppCheckbox from "../../../../common/components/inputs/AppCheckbox";
import AppDateField from "../../../../common/components/inputs/AppDateField";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import * as modificationSouscriptionFormNames from "../others/modificationSouscriptionFormNames";
import {modificationSouscriptionInitialValues} from "../others/modificationSouscriptionInitialValues";
import {modificationSouscriptionValidationSchema} from "../others/modificationSouscriptionValidationSchemas";
import {
    getSouscriptionToModifyAction,
    modificationSouscriptionAction,
    modificationSouscriptionReinitializationAction,
} from "../state/modificationSouscriptionActions";
import {STATUS_MODIFICATION_FORM_NAME} from "../others/modificationSouscriptionFormNames";
import AppSelect from "../../../../common/components/inputs/AppSelect";
import * as consultationSouscriptionFormNames
  from "../../consultationSouscriptions/others/consultationSouscriptionsFormNames";
import useLocalReferentiel from "../../../../common/hooks/useLocalReferentiel";
import * as localReferentielKeys from "../../../../common/localReferentiel/others/localReferentielKeys";
import AppSpecificReferentielField from "../../../../common/components/inputs/AppSpecificReferentielField";
import AppSimplePopupReferentielField from "../../../../common/components/inputs/AppSimplePopupReferentielField";
import AppAutocomplete from "../../../../common/components/inputs/AppAutocomplete";
import {printInitialState as rolesOperateurOptions} from "../../../../common/utils/helpers";


const ModificationSouscription = ({ open, close, selected }) => {
  const dispatch = useDispatch();
  const souscriptionId = selected?.id;
  const [valueChecked, setValueChecked] = useState(false);
  const {
    content: souscriptionToModify,
    isLoading: isSouscriptionToModifyLoading,
  } = useSelector(
    (state) => state.souscription.modificationSouscription.souscriptionToModify
  );
  const [selectedRole, setSelectedRole] = useState(null);
  const [operateurId, setOperateurId] = useState(<AppTextField label="Opérateur" disabled />);

  const roleOperateur = souscriptionToModify?.tarificationPackage?.roleOperateur; // Extract role from the subscription

  const [
    statutSouscriptionOptions,
  ] = useLocalReferentiel([
    localReferentielKeys.STATUS_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY,
  ]);


  const {
    isLoading: isModificationSouscriptionLoading,
    isSuccessed: isModificationSouscriptionSuccessed,
    hasError: hasModificationSouscriptionError,
  } = useSelector(
    (state) =>
      state.souscription.modificationSouscription.envoiModificationSouscription
  );

  useEffect(() => {
    dispatch(getSouscriptionToModifyAction(souscriptionId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [souscriptionId]);

  useEffect(() => {
    if (hasModificationSouscriptionError) {
      dispatch(modificationSouscriptionReinitializationAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasModificationSouscriptionError]);

  useEffect(() => {
    if (isModificationSouscriptionSuccessed) {
      dispatch(modificationSouscriptionReinitializationAction());
      close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModificationSouscriptionSuccessed]);

  useEffect(() => {
    let fieldToRender;

    switch (roleOperateur?.code) {
      case "ROLE_VUPORTUARIA_CONSIGNATARIO":
        fieldToRender = (
            <AppSpecificReferentielField
                title="Recherche de consignataires"
                searchKey="CONSIGNATAIRES"
                label="Consignataire"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_OPERADOR":
        fieldToRender = (
            <AppSpecificReferentielField
                title="Recherche d'opérateurs"
                searchKey="OPERATEURS_MANUTENTION"
                label="Opérateur"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_ANP":
        fieldToRender = (
            <AppSimplePopupReferentielField
                title="Recherche de ports"
                searchKey="LISTE_PORTS"
                label="Port"
                descriptionLabel="Nom"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_TRANSITARIO":
        fieldToRender = (
            <AppSpecificReferentielField
                title="Recherche de transitaires"
                searchKey="TRANSITAIRES"
                label="Transitaire"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_IMPORTADOR":
        fieldToRender = (
            <AppSpecificReferentielField
                title="Recherche d'importateurs"
                searchKey="OPERATEURS_IMP_EXP"
                label="Importateur"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_BANCO":
        fieldToRender = (
            <AppSimplePopupReferentielField
                title="Recherche de banques"
                searchKey="LISTE_BANQUES"
                descriptionLabel="Banque"
                label="Banque"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      default:
        fieldToRender = <AppTextField label="Opérateur" disabled />;
        break;
      }
    setOperateurId(fieldToRender);
    setSelectedRole(roleOperateur);
  }, [roleOperateur]); // Re-run the effect if the role changes



  const submitHandler = (values) => {
    const data1 = Object.assign({}, values, {
      souscriptionSuspendu: valueChecked,
      roleOperateurId:roleOperateur.id,
    });
    dispatch(modificationSouscriptionAction({ souscriptionId, data: data1 }));
  };

  const suspendreSouscriptionHandler = (event) => {
    const isChecked = event.target.checked;
    setValueChecked(isChecked);
  };


  const formRef = useRef();
  return (
    <>
      <PuiLoadingBackdrop
        open={
          isSouscriptionToModifyLoading || isModificationSouscriptionLoading
        }
      />
      <PuiDialog
        onClose={close}
        open={open}
        maxWidth="lg"
        fullWidth
        title="Gestion des souscriptions"
        // loading={ isSouscriptionToModifyLoading}
      >
        <PuiSection title="Modification de la souscription">
          <Formik
            initialValues={modificationSouscriptionInitialValues}
            validationSchema={modificationSouscriptionValidationSchema}
            onSubmit={submitHandler}
            innerRef={formRef}
          >
            <PuiFormikForm>
              <PuiGrid container marginTop={1}>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppTextField
                    label="Code du package"
                    name={
                      modificationSouscriptionFormNames.CODE_PACKAGE_FORM_NAME
                    }
                    value={souscriptionToModify.codePackage}
                    consultation
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppTextField
                    label="Identifiant de la sousciption"
                    name={
                      modificationSouscriptionFormNames.IDENTIFIANT_SOUSCRIPTION_FORM_NAME
                    }
                    value={souscriptionToModify.identifiantSouscription}
                    consultation
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={12}>
                  <AppTextField
                    label="Transactions restantes"
                    name={
                      modificationSouscriptionFormNames.TRANSACTIONS_RESTANTES_FORM_NAME
                    }
                    value={
                      souscriptionToModify.tarificationSummary?.restantLibelle
                    }
                    consultation
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppDateField
                    label="Du (Date fin de validité)"
                    name={
                      modificationSouscriptionFormNames.VALIDITE_DU_FORM_NAME
                    }
                    value={souscriptionToModify.souscriptionDu}
                  />
                </PuiGrid>

                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppDateField
                    label="Au (Date fin de validité)"
                    name={
                      modificationSouscriptionFormNames.VALIDITE_AU_FORM_NAME
                    }
                    value={souscriptionToModify.souscriptionAu}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppSelect
                      label="Statut de la souscription"
                      name={
                        modificationSouscriptionFormNames.STATUS_MODIFICATION_FORM_NAME
                      }
                      options={statutSouscriptionOptions.content}
                      loading={statutSouscriptionOptions.isLoading}
                      error={statutSouscriptionOptions.hasError}
                      helperText={statutSouscriptionOptions.error}
                      getOptionLabel={(option) => option.description}
                      getOptionValue={(option) => option.code}
                  />
                </PuiGrid>

                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppTextField
                    label="Solde suplémentaire"
                    name={
                      modificationSouscriptionFormNames.SOLDE_SUPLEMENTAIRE_FORM_NAME
                    }
                    value={souscriptionToModify.solde ?? "0"}
                  />
                </PuiGrid>

                <PuiGrid item xs={12} sm={6} md={6}>
                  {React.cloneElement(operateurId, {
                    name: "operateurId", // Pass name dynamically
                  })}
                </PuiGrid>

                <PuiGrid item xs={12} sm={6} md={6}>
                  <AppCheckbox
                    sx={{ marginLeft: "-12px", marginTop: "10px" }}
                    label="Suspendre Souscription"
                    name={
                      modificationSouscriptionFormNames.SOUSCRIPTION_SUSPENDU_FORM_NAME
                    }
                    defaultValue={souscriptionToModify.souscriptionSuspendu}
                    onChange={suspendreSouscriptionHandler}
                  />
                </PuiGrid>


                <PuiGrid item xs={12}>
                  <AppTextField
                    label="Motif de modification"
                    name={
                      modificationSouscriptionFormNames.MOTIF_MODIFICATION_FORM_NAME
                    }
                    value={souscriptionToModify.motifModification}
                    multiline
                    rows={6}
                    required
                  />
                </PuiGrid>
              </PuiGrid>
            </PuiFormikForm>
          </Formik>
        </PuiSection>
        <PuiSection sx={{ marginTop: 2, padding: 1 }}>
          <PuiGrid container justifyContent="flex-end">
            <PuiGrid item>
              <AppButton
                color="tertiary"
                startIcon={<BackspaceIcon />}
                onClick={() => {
                  formRef.current.resetForm();
                }}
              >
                Effacer
              </AppButton>
            </PuiGrid>
            <PuiGrid item>
              <AppButton
                color="primary"
                startIcon={<EditIcon />}
                onClick={() => {
                  formRef.current.submitForm();
                }}
              >
                Modifier
              </AppButton>
            </PuiGrid>
          </PuiGrid>
        </PuiSection>
      </PuiDialog>
    </>
  );
};
export default ModificationSouscription;
